import styled from 'styled-components';

export const Container = styled.div`
  .plan-card {
    border-radius: 18px;
    border: 1px solid #cfcfcf;
  }

  .badge-plan-type {
    background-color: #0d875e;
    color: #fff;
    padding: 5px 19px;
    font-size: 12px;
  }

  .prices {
    button {
      background-color: #0d875e;
      border-radius: 65px;
      color: #fff;
      font-weight: bold;
      padding-bottom: 3px;
    }

    .boleto-price {
      font-weight: 500;
    }

    .card-price {
      color: #0d875e;
    }

    .discount {
      font-size: 15px;
      color: #212529;
    }

    .installment {
      color: #757575;
    }
  }
`;
